<template>
  <section class="pt-60 pb-60 mt-10 mt-lg-0">
    <div class="pb-30 br-bottom-n3">
      <div data-aos="zoom-in" class="page-heading">
        <h3
          class="page-title fs-onefw-semibold n5-color mb-2 mb-md-3 text-center"
        >
          Online Resume
        </h3>

        <a
          href="assets/images/Zakaria_Resume.pdf"
          class="w-max primary-btn bg1-color fw-medium n1-color px-3 px-md-6 py-2 py-md-4 rounded-pill d-flex align-items-center gap-2 mx-auto mt-5"
          download
        >
          <i class="ph ph-file-pdf"></i>Download PDF Version
        </a>
      </div>
    </div>

    <div class="container mt-8 mt-md-15" id="resume">
      <div
        data-aos="fade-up"
        class="bgn2-color p-4 p-sm-8 p-md-15 rounded-5 brn4"
      >
        <div
          class="d-flex flex-wrap justify-content-between align-items-center gap-3 br-bottom-n3 pb-3 pb-md-6"
        >
          <div>
            <h2 class="display-three p1-color fw-semibold">Zakaria Djeddai</h2>
            <span class="n4-color fs-six fw-medium">Full-Stack Developer</span>
          </div>
          <div class="ps-5 br-left-n3">
            <ul class="d-flex flex-column gap-3">
              <li>
                <a
                  href="tel:+213669966723"
                  class="d-flex gap-2 align-items-center n4-color"
                >
                  <i class="ph ph-phone"></i> +213669966723</a
                >
              </li>
              <li>
                <a
                  href="mailto:zakareiadjeddai@gmail.com"
                  class="d-flex gap-2 align-items-center n4-color"
                >
                  <i class="ph ph-envelope-simple"></i
                  >zakareiadjeddai@gmail.com</a
                >
              </li>
              <li class="d-flex gap-2 align-items-center n4-color">
                <i class="ph ph-map-pin"></i> Algeria
              </li>
              <li class="d-flex gap-2 align-items-center n4-color">
                <i class="ph ph-globe"></i>
                <a href="https://zakariadjeddai.com" target="_blank"
                  >zakariadjeddai.com</a
                >
              </li>
            </ul>
          </div>
        </div>

        <div
          class="d-flex flex-wrap flex-md-nowrap align-items-center gap-5 gap-md-10 pb-4 pb-md-8 br-bottom-n3 pt-60"
        >
          <div class="resume-profile flex-shrink-0">
            <img
              src="assets/images/profile.jpg"
              alt="profile"
              class="object-fit-cover"
              width="100%"
              height="159"
            />
          </div>
          <div class="n42-color fs-seven">
            I'm Djeddai Zakaria, a full-stack developer from Algeria with 2+
            years of professional experience in Vue.js and React.js development.
            I specialize in building responsive, interactive interfaces using
            modern JavaScript frameworks, with expertise in Vue.js, React.js,
            Material UI, and modern front-end tooling.
            <div class="mb-4"></div>
            My professional journey includes working with international teams on
            energy management platforms and healthcare applications. I have
            experience with Laravel for backend integration and API development
            through personal projects and collaborative work. I'm proficient
            with Git, GitHub, and modern build tools, ensuring clean,
            maintainable, and scalable codebases. I continuously learn emerging
            front-end technologies and best practices, focusing on delivering
            efficient digital solutions both independently and as part of a
            team.
          </div>
        </div>

        <div class="resume-section row g-6 pt-60 pb-60 br-bottom-n3">
          <div class="col-md-8 col-lg-12 col-xl-8 col-xxl-9">
            <div class="d-flex align-items-center gap-2 mb-5 mb-md-10">
              <div class="title-line2"></div>
              <h2 class="fs-three p1-color fw-semibold">Work Experiences</h2>
            </div>

            <div class="mb-8 mb-md-14">
              <div
                class="d-flex flex-wrap gap-1 gap-sm-3 justify-content-between align-items-center"
              >
                <span class="n5-color fs-six fw-medium"
                  >Front-End Developer (React.js)</span
                >
                <span class="n4-color fs-eight"
                  >Healthcare Startup (Remote)</span
                >
                <span class="n4-color fs-eight">January 2025 - March 2025</span>
              </div>
              <p class="n42-color fs-seven my-2 my-md-5">
                As a Front-End Developer at a healthcare startup, I'm developing
                a comprehensive doctor multifunction web application using
                React.js and Material UI. The platform enables doctors to manage
                appointments, patient records, and medical procedures
                efficiently. I focus on creating intuitive user interfaces and
                implementing real-time features to enhance the healthcare
                experience.
              </p>

              <ul class="d-flex flex-column gap-3 ms-6 ms-lg-10">
                <li class="n42-color fs-seven">
                  Developed responsive and accessible user interfaces using
                  React.js and Material UI components.
                </li>
                <li class="n42-color fs-seven">
                  Implemented real-time features for appointment scheduling and
                  patient management.
                </li>
                <li class="n42-color fs-seven">
                  Integrated RESTful APIs and WebSocket connections for live
                  updates and notifications.
                </li>
                <li class="n42-color fs-seven">
                  Collaborated with the backend team to design and implement
                  efficient data flow and state management.
                </li>
              </ul>
            </div>

            <div class="mb-8 mb-md-14">
              <div
                class="d-flex flex-wrap gap-1 gap-sm-3 justify-content-between align-items-center"
              >
                <span class="n5-color fs-six fw-medium"
                  >Front-End Developer (Vue.js)</span
                >
                <span class="n4-color fs-eight"
                  ><a href="https://www.mieyar.ae/" target="_blank"
                    >Mieyar (UAE)</a
                  >
                  | February 2024 - November 2024</span
                >
              </div>
              <p class="n42-color fs-seven my-2 my-md-5">
                Worked as a Front-End Developer at Mieyar, developing and
                optimizing user interfaces for a web application that benchmarks
                property energy and water performance. Used Vue.js to create
                responsive designs and smooth user experiences with efficient
                data integration. Collaborated with the team to enhance
                functionality, enabling users to compare their building's energy
                and water consumption with similar properties.
              </p>

              <ul class="d-flex flex-column gap-3 ms-6 ms-lg-10">
                <li class="n42-color fs-seven">
                  Developed dynamic, responsive user interfaces using Vue.js and
                  modern frontend tooling.
                </li>
                <li class="n42-color fs-seven">
                  Collaborated with cross-functional teams to integrate RESTful
                  APIs and ensure seamless functionality.
                </li>
                <li class="n42-color fs-seven">
                  Performed basic Laravel tasks, supporting backend integration
                  and simple CRUD operations.
                </li>
                <li class="n42-color fs-seven">
                  Optimized application performance and maintained code quality
                  through modern development practices.
                </li>
              </ul>
            </div>

            <div class="mb-8 mb-md-14">
              <div
                class="d-flex flex-wrap gap-1 gap-sm-3 justify-content-between align-items-center"
              >
                <span class="n5-color fs-six fw-medium"
                  >Front-End Developer (React.js, Vue.js)</span
                >
                <span class="n4-color fs-eight">
                  <a href="https://originova.io/" target="_blank"
                    >Originova (Algeria)</a
                  >
                  | December 2023 - February 2024</span
                >
              </div>
              <p class="n42-color fs-seven my-2 my-md-5">
                Worked as a Front-End Developer at Originova, focusing on
                developing the frontend of web applications with Vue.js and
                React.js, while gaining exposure to Laravel and MySQL for
                backend integration. Collaborated on clean code practices, UI/UX
                implementation, and frontend-backend integration to deliver
                functional solutions.
              </p>
              <ul class="d-flex flex-column gap-3 ms-6 ms-lg-10">
                <li class="n42-color fs-seven">
                  Built web applications using Vue.js, React.js, Tailwind CSS,
                  and RESTful API integrations.
                </li>
                <li class="n42-color fs-seven">
                  Gained hands-on experience with Laravel for basic backend
                  operations and API integrations.
                </li>
                <li class="n42-color fs-seven">
                  Collaborated with backend developers to implement scalable
                  workflows and maintain clean, reusable frontend code.
                </li>
              </ul>
            </div>

            <div class="mb-10 mb-md-18">
              <div
                class="d-flex flex-wrap gap-1 gap-sm-3 justify-content-between align-items-center"
              >
                <span class="n5-color fs-six fw-medium"
                  >Freelance Developer</span
                >
                <span class="n4-color fs-eight">
                  March 2022 - December 2023</span
                >
              </div>
              <p class="n42-color fs-seven my-2 my-md-5">
                Worked as a Freelance Developer, building responsive websites
                and web applications using HTML5, CSS3, JavaScript, and Vue.js.
                Delivered custom solutions focused on user experience and client
                satisfaction. Used Laravel for basic backend functionality in
                select projects.
              </p>
              <ul class="d-flex flex-column gap-3 ms-6 ms-lg-10">
                <li class="n42-color fs-seven">
                  Delivered custom websites for clients, prioritizing responsive
                  design and user experience using HTML5, CSS3, and JavaScript.
                </li>
                <li class="n42-color fs-seven">
                  Managed project cycles from requirement gathering to
                  deployment, ensuring client satisfaction and timely delivery.
                </li>
                <li class="n42-color fs-seven">
                  Created engaging interfaces with Vue.js and some React.js,
                  with Laravel backend integration for smaller projects.
                </li>
              </ul>
            </div>

            <div class="d-flex align-items-center gap-2 mb-5 mb-md-10">
              <div class="title-line2"></div>
              <h2 class="fs-three p1-color fw-semibold">Projects</h2>
            </div>

            <div class="mb-6 mb-md-12">
              <div
                class="d-flex flex-wrap gap-1 gap-sm-3 justify-content-between align-items-center mb-2 mb-md-4"
              >
                <span class="n5-color fs-six fw-medium"
                  >PC Hardware Shop – Custom E-commerce Website</span
                >
                <span class="n42-color fs-eight">
                  <a
                    href="https://zerostech.shop/"
                    target="_blank"
                    class="p1-color fs-eight"
                    >Client Project</a
                  >
                </span>
              </div>
              <p class="n42-color fs-seven">
                A complete e-commerce platform built for a local Algerian PC
                parts store using Vue.js and Laravel. The site allows customers
                to browse components, build compatible PCs, and order directly
                with a cash-on-delivery system. Features include real-time part
                compatibility validation, dynamic cart system, and a
                comprehensive admin dashboard for inventory management. Built
                with Vuexy admin template and MySQL database, the platform
                includes multi-category product management, image uploads, stock
                control, and a public API for seamless integration.
              </p>
            </div>

            <div class="mb-6 mb-md-12">
              <div
                class="d-flex flex-wrap gap-1 gap-sm-3 justify-content-between align-items-center mb-2 mb-md-4"
              >
                <span class="n5-color fs-six fw-medium"
                  >Healthcare Management Platform</span
                >
                <span class="n42-color fs-eight">Yadoct</span>
              </div>
              <p class="n42-color fs-seven">
                A comprehensive healthcare management system built with React.js
                and Material UI, featuring appointment scheduling, patient
                records management, and real-time notifications. The application
                includes a responsive dashboard, role-based access control, and
                integration with healthcare APIs. Built with modern React
                practices including hooks, context API, and custom hooks for
                state management. Implemented features like real-time chat,
                video consultations, and electronic health records management.
              </p>
            </div>

            <div class="mb-6 mb-md-12">
              <div
                class="d-flex flex-wrap gap-1 gap-sm-3 justify-content-between align-items-center mb-2 mb-md-4"
              >
                <span class="n5-color fs-six fw-medium"
                  >Property Energy Benchmarking Platform</span
                >
                <span class="n42-color fs-eight">
                  <a
                    href="https://www.mieyar.ae/"
                    target="_blank"
                    class="p1-color fs-eight"
                    >Mieyar</a
                  >
                </span>
              </div>
              <p class="n42-color fs-seven">
                Developed a sophisticated web application using Vue.js that
                enables property owners to benchmark their energy and water
                consumption against similar properties. Implemented interactive
                data visualization using Chart.js, real-time data updates, and a
                comprehensive reporting system. The platform includes features
                for data import/export, historical trend analysis, and
                customizable dashboards for property managers.
              </p>
            </div>

            <div class="mb-6 mb-md-12">
              <div
                class="d-flex flex-wrap gap-1 gap-sm-3 justify-content-between align-items-center mb-2 mb-md-4"
              >
                <span class="n5-color fs-six fw-medium"
                  >Tjara – Multi-Vendor Marketplace Platform</span
                >
                <span class="n42-color fs-eight">
                  <a
                    href="https://tjara.com"
                    target="_blank"
                    class="p1-color fs-eight"
                    >Tjara</a
                  >
                </span>
              </div>
              <p class="n42-color fs-seven">
                A comprehensive multi-vendor marketplace platform built with
                React.js and Laravel, enabling multiple sellers to manage their
                products through independent dashboards. Features include vendor
                registration system, multi-cart functionality allowing customers
                to purchase from multiple sellers, commission management for
                platform earnings, and secure payment gateway integration. The
                platform includes a powerful admin panel for managing users,
                vendors, products, and commissions, with a mobile-responsive
                design optimized for all devices.
              </p>
            </div>

            <div class="mb-6 mb-md-12">
              <div
                class="d-flex flex-wrap gap-1 gap-sm-3 justify-content-between align-items-center mb-2 mb-md-4"
              >
                <span class="n5-color fs-six fw-medium"
                  >Location-Based Business Discovery App</span
                >
                <span class="n42-color fs-eight">
                  <a
                    class="p1-color fs-eight"
                    href="https://www.instagram.com/spotter.dz/?hl=en"
                    target="_blank"
                    >Spotter DZ</a
                  >
                </span>
              </div>
              <p class="n42-color fs-seven">
                Built a mobile-first application using Vue.js and Ionic
                Framework that helps users discover local businesses and
                services. Implemented features like real-time location tracking,
                business categorization, user reviews, and a sophisticated
                search system with filters. The app includes a business owner
                dashboard for managing listings and analytics. Successfully
                deployed on Google Play Store with over 1000+ active users.
              </p>
            </div>

            <div class="mb-6 mb-md-12">
              <div
                class="d-flex flex-wrap gap-1 gap-sm-3 justify-content-between align-items-center mb-2 mb-md-4"
              >
                <span class="n5-color fs-six fw-medium"
                  >Restaurant Management System</span
                >
                <a
                  href="https://qwikly.io/"
                  target="_blank"
                  class="p1-color fs-eight"
                  >Qwikly</a
                >
              </div>
              <p class="n42-color fs-seven">
                Created a comprehensive restaurant management solution using
                Vue.js and Laravel. Features include real-time order management,
                table reservations, menu customization, inventory tracking, and
                staff scheduling. Implemented a mobile-responsive interface for
                both staff and customers, with features like QR code menu
                scanning, online ordering, and automated kitchen order printing.
                The system includes analytics dashboard for business insights
                and performance metrics.
              </p>
            </div>

            <div class="mb-6 mb-md-12">
              <div
                class="d-flex flex-wrap gap-1 gap-sm-3 justify-content-between align-items-center mb-2 mb-md-4"
              >
                <span class="n5-color fs-six fw-medium"
                  >Task Management System</span
                >
                <span class="n42-color fs-eight">Personal Project</span>
              </div>
              <p class="n42-color fs-seven">
                Developed a task management system using Vue.js and Laravel,
                featuring real-time task updates, team collaboration tools, and
                project tracking. Implemented features like task assignment,
                progress tracking, deadline management, and automated
                notifications. The system includes a calendar view, Gantt chart
                visualization, and reporting tools for project analytics. Built
                with a focus on user experience and team productivity.
              </p>
            </div>

            <router-link
              :to="{ name: 'portfolio' }"
              class="primary-btn px-3 px-md-6 py-2 py-md-4 fw-medium rounded-pill d-flex align-items-center gap-2"
            >
              <i class="ph ph-arrow-right"></i> View Full Portfolio
            </router-link>
          </div>

          <!-- right side  -->
          <div class="col-md-4 col-lg-12 col-xl-4 col-xxl-3">
            <div
              class="ps-4 ps-xxl-7 br-left-n3 d-flex flex-column gap-8 gap-md-15"
            >
              <!-- skills  -->
              <div>
                <div class="d-flex align-items-center gap-2 mb-5 mb-md-10">
                  <div class="title-line2"></div>
                  <h2 class="fs-three p1-color fw-semibold">Skills</h2>
                </div>

                <div class="mb-3 mb-md-6">
                  <h5 class="fs-six n5-color fw-medium mb-2 mb-md-4">
                    Technical Skills
                  </h5>
                  <ul class="d-flex flex-column gap-3 ms-6 ms-lg-10">
                    <li class="n4-color fs-seven">
                      HTML, CSS, Bootstrap, JavaScript
                    </li>
                    <li class="n4-color fs-seven">
                      Vue.js (Vue 3), State Management (Vuex/Pinia), Vue Router,
                      Component Libraries (Vuetify, Tailwind CSS)
                    </li>
                    <li class="n4-color fs-seven">
                      React.js, Material UI, Component Libraries
                    </li>
                    <li class="n4-color fs-seven">
                      PHP (Laravel) - Personal Projects
                    </li>
                    <li class="n4-color fs-seven">
                      MySQL, Database Design & Management - Personal Projects
                    </li>
                    <li class="n4-color fs-seven">
                      Clean Code & Best Practices
                    </li>
                    <li class="n4-color fs-seven">
                      API Development & Integration (RESTful APIs, JSON, Laravel
                      JWT authentication)
                    </li>
                    <li class="n4-color fs-seven">
                      Collaboration with cross-functional teams to deliver
                      high-quality software
                    </li>
                  </ul>
                </div>

                <div>
                  <h5 class="fs-six n5-color fw-medium mb-2 mb-md-4">
                    Professional Skills
                  </h5>
                  <ul class="d-flex flex-column gap-3 ms-6 ms-lg-10">
                    <li class="n4-color fs-seven">
                      Excellent communication skills, both written and verbal
                    </li>
                    <li class="n4-color fs-seven">
                      Strong team player with the ability to collaborate
                      effectively in cross-functional teams
                    </li>
                    <li class="n4-color fs-seven">
                      Analytical and solution-oriented problem solver with a
                      focus on creating efficient solutions
                    </li>
                    <li class="n4-color fs-seven">
                      Effective time management and ability to meet deadlines in
                      fast-paced environments
                    </li>
                    <li class="n4-color fs-seven">
                      Adaptable and open to feedback for continuous learning and
                      improvement
                    </li>
                    <li class="n4-color fs-seven">
                      Passionate about building scalable systems and delivering
                      high-quality software
                    </li>
                  </ul>
                </div>
              </div>

              <!-- education  -->
              <div>
                <div class="d-flex align-items-center gap-2 mb-3 mb-md-6">
                  <div class="title-line2"></div>
                  <h2 class="fs-three p1-color fw-semibold">Education</h2>
                </div>
                <div class="d-flex gap-2 mb-3 mb-md-5">
                  <i class="ph ph-graduation-cap fs-six p1-color"></i>
                  <div>
                    <span class="n4-color fs-seven"
                      >Bachelor's Degree in Computer Science, Batna University,
                      Algeria (In Progress)</span
                    >
                    <span class="n4-color fs-eleven">2023 - Present</span>
                  </div>
                </div>
              </div>
              <!-- Languages  -->
              <div>
                <div class="d-flex align-items-center gap-2 mb-3 mb-md-6">
                  <div class="title-line2"></div>
                  <h2 class="fs-three p1-color fw-semibold">Languages</h2>
                </div>
                <ul class="d-flex flex-column gap-3 ms-6 ms-lg-10">
                  <li class="n4-color fs-seven">English (Professional)</li>
                  <li class="n4-color fs-seven">Arabic (Native)</li>
                </ul>
              </div>
              <!-- Interests  -->
              <div>
                <div class="d-flex align-items-center gap-2 mb-3 mb-md-6">
                  <div class="title-line2"></div>
                  <h2 class="fs-three p1-color fw-semibold">Interests</h2>
                </div>
                <ul class="d-flex flex-column gap-3 ms-6 ms-lg-10">
                  <li class="n4-color fs-seven">Sci-Fi Movies</li>
                  <li class="n4-color fs-seven">Tech Contents</li>
                  <li class="n4-color fs-seven">
                    Programming Documentations & Articles
                  </li>
                  <li class="n4-color fs-seven">Competitive Games</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div
          class="d-flex flex-wrap gap-2 gap-md-3 gap-md-5 align-items-center justify-content-center mt-4 mt-md-8"
        >
          <a
            href="https://github.com/zakareiaa"
            target="_blank"
            class="d-flex gap-1 align-items-center resume-icon"
          >
            <div class="social-icon">
              <i class="ph ph-github-logo p1-color"></i>
            </div>
            <span class="fs-nine n4-color">github.com/zakareiaa</span>
          </a>
          <a
            href="https://www.linkedin.com/in/zakaria-djeddai/"
            target="_blank"
            class="d-flex gap-1 align-items-center resume-icon"
          >
            <div class="social-icon">
              <i class="ph ph-linkedin-logo p1-color"></i>
            </div>
            <span class="fs-nine n4-color"
              >linkedin.com/in/zakaria-djeddai</span
            >
          </a>
          <a
            href="https://www.instagram.com/zaakareia"
            target="_blank"
            class="d-flex gap-1 align-items-center resume-icon"
          >
            <div class="social-icon">
              <i class="ph ph-instagram-logo p1-color"></i>
            </div>
            <span class="fs-nine n4-color">@zaakareia</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ResumePage",
  methods: {
    downloadResume() {},
  },
};
</script>
